/* Studio Software — motion details on every page, kept quiet: a faint animated dot field, the site's own cursor,
   a thin cyan→magenta scroll bar, sections that rise in, and the hero logo coming apart as you scroll
   (the cyan dots burst away from the walking boy). Nothing runs with prefers-reduced-motion;
   touch screens get only the scroll effects. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  var SRC = document.currentScript && document.currentScript.src || '';  /* only known while the script first runs */

  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }

  ready(function () {
    root.classList.add('sb-fx');

    /* animated GIFs arrive as stills (snippets/sb-img.liquid); once the page has loaded, each one plays when it is on
       screen. With reduced motion this file stops early, so they stay still. */
    function playGifs() {
      var stills = Array.prototype.slice.call(document.querySelectorAll('img[data-gif]'));
      if (!stills.length) return;
      var play = function (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = img.dataset.gif; img.removeAttribute('data-gif'); };
      if (!('IntersectionObserver' in window)) { stills.forEach(play); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { play(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '200px' });
      stills.forEach(function (img) { io.observe(img); });
    }
    if (document.readyState === 'complete') playGifs(); else window.addEventListener('load', playGifs);

    /* scroll progress bar */
    var bar = document.createElement('div');
    bar.className = 'sb-fx-bar';
    document.body.appendChild(bar);

    /* hero logo (snippets/sb-logo-anim.liquid): the boy walks only as the page scrolls, slowly, through every frame
       of the original walk redrawn as smooth vectors (assets/sb-boy-frames.json, built by brand/logo_anim.py); the
       cyan dots move outward with the scroll and never stop, until they leave the screen. Scrolling back up brings
       everything home. */
    var logo = document.querySelector('.sb-hero__art .sb-logo');
    var ringDots = logo ? Array.prototype.slice.call(logo.querySelectorAll('.sb-logo__dot')) : [];
    var svg = logo && logo.querySelector('.sb-logo__dots');
    var boy = logo && logo.querySelector('.sb-logo__boy');
    var pose = boy && boy.querySelector('path'), walk = null, shown = -1;
    var CYCLE = 1440; /* px of scroll per walk cycle: one video frame every ~14 px */
    function afterLoad(fn) { if (document.readyState === 'complete') setTimeout(fn, 0); else window.addEventListener('load', fn); }
    if (pose && boy.dataset.frames && window.fetch) afterLoad(function () {
      fetch(boy.dataset.frames).then(function (r) { return r.json(); }).then(function (d) {
        /* body: frame 0 absolute, then deltas → absolute points per frame */
        var len = d.n * 2, body = [], prev = null, snap = {};
        for (var k = 0; k < d.keys; k++) {
          var cur = d.body.slice(k * len, k * len + len);
          if (prev) for (var i = 0; i < len; i++) cur[i] += prev[i];
          body.push(cur); prev = cur;
        }
        d.snap.forEach(function (i) { snap[i] = 1; });
        walk = { keys: d.keys, body: body, head: d.head, holes: d.holes, snap: snap };
        if (logo && ringDots.length) renderHero(heroY === null ? window.scrollY : heroY);
      }).catch(function () {});
    });  /* the walk (~65 KB) loads after the page: the boy shows frame 0 until then */
    function r1(v) { return Math.round(v * 10) / 10; }
    /* closed quadratic B-spline through the midpoints of the points (same drawing as logo_anim.py) */
    function spline(p) {
      var n = p.length / 2, s = '';
      for (var i = 0; i < n; i++) {
        var j = (i + 1) % n;
        s += 'Q' + r1(p[2 * i]) + ' ' + r1(p[2 * i + 1]) + ' ' + r1((p[2 * i] + p[2 * j]) / 2) + ' ' + r1((p[2 * i + 1] + p[2 * j + 1]) / 2);
      }
      return 'M' + r1((p[2 * n - 2] + p[0]) / 2) + ' ' + r1((p[2 * n - 1] + p[1]) / 2) + s + 'Z';
    }
    function mix(a, b, w) { var o = new Array(a.length); for (var i = 0; i < a.length; i++) o[i] = a[i] + (b[i] - a[i]) * w; return o; }
    /* the boy at video position t: a real frame, or a blend of two consecutive real frames (cut instead where they
       differ in shape, see logo_anim.py) */
    function drawWalk(t) {
      var a = Math.floor(t) % walk.keys, b = (a + 1) % walk.keys, w = t - Math.floor(t);
      if (walk.snap[a]) { if (w >= 0.5) a = b; w = 0; }
      var d = spline(w ? mix(walk.body[a], walk.body[b], w) : walk.body[a]);
      var H = walk.head, cx = r1(H[3 * a] + (H[3 * b] - H[3 * a]) * w), cy = r1(H[3 * a + 1] + (H[3 * b + 1] - H[3 * a + 1]) * w),
          r = r1(H[3 * a + 2] + (H[3 * b + 2] - H[3 * a + 2]) * w);
      d += 'M' + r1(cx - r) + ' ' + cy + 'A' + r + ' ' + r + ' 0 1 1 ' + r1(cx + r) + ' ' + cy + 'A' + r + ' ' + r + ' 0 1 1 ' + r1(cx - r) + ' ' + cy + 'Z';
      walk.holes[a].forEach(function (h) {
        d += spline(w && h[0] >= 0 ? mix(h.slice(1), walk.holes[b][h[0]].slice(1), w) : h.slice(1));
      });
      pose.setAttribute('d', d);
    }
    /* the dots lie on an arc around the boy: fit that circle and send every dot straight out from its centre,
       so the trail grows as one ring. Smaller dots travel faster. */
    var flights = null;
    function aim() {
      var c = ringDots.map(function (d) { var b = d.getBBox(); return [b.x + b.width / 2, b.y + b.height / 2, b.width]; });
      var s = [0, 0, 0, 0, 0, 0, 0, 0, 0]; /* Σx Σy Σxx Σyy Σxy Σxz Σyz Σz n — least-squares circle (Kåsa) */
      c.forEach(function (p) { var z = p[0] * p[0] + p[1] * p[1]; s[0] += p[0]; s[1] += p[1]; s[2] += p[0] * p[0]; s[3] += p[1] * p[1]; s[4] += p[0] * p[1]; s[5] += p[0] * z; s[6] += p[1] * z; s[7] += z; s[8]++; });
      var m = [[s[2], s[4], s[0]], [s[4], s[3], s[1]], [s[0], s[1], s[8]]], r = [-s[5], -s[6], -s[7]];
      function det(a) { return a[0][0] * (a[1][1] * a[2][2] - a[1][2] * a[2][1]) - a[0][1] * (a[1][0] * a[2][2] - a[1][2] * a[2][0]) + a[0][2] * (a[1][0] * a[2][1] - a[1][1] * a[2][0]); }
      function solve(k) { return det(m.map(function (row, i) { return row.map(function (v, j) { return j === k ? r[i] : v; }); })) / det(m); }
      var cx = -solve(0) / 2, cy = -solve(1) / 2, big = Math.max.apply(null, c.map(function (p) { return p[2]; }));
      flights = c.map(function (p) {
        var dx = p[0] - cx, dy = p[1] - cy, n = Math.sqrt(dx * dx + dy * dy) || 1;
        return { x: dx / n, y: dy / n, v: 1.6 - 0.8 * p[2] / big };
      });
    }
    /* the hero follows the scroll through an easing loop that runs at the screen's refresh rate: a wheel moves the
       page in jumps of ~100 px, and the boy and the dots glide through every in-between pose instead of jumping */
    var heroY = null, heroRunning = false;
    function heroFrame() {
      var target = window.scrollY;
      heroY += (target - heroY) * 0.16;
      if (Math.abs(target - heroY) < 0.05) heroY = target;
      renderHero(heroY);
      if (heroY !== target) requestAnimationFrame(heroFrame); else heroRunning = false;
    }
    function paintHero() {
      if (!logo || !ringDots.length) return;
      if (heroY === null) { heroY = window.scrollY; renderHero(heroY); return; }
      if (!heroRunning) { heroRunning = true; requestAnimationFrame(heroFrame); }
    }
    function renderHero(y) {
      if (!flights) aim();
      var unit = svg.viewBox.baseVal.width / (svg.clientWidth || 1); /* SVG units per screen px */
      /* he walks only while the page moves, and slowly: any fraction of a video frame is drawn */
      if (walk) {
        var t = Math.round((y / CYCLE) * walk.keys * 100) / 100;
        if (t !== shown) { drawWalk(t); shown = t; }
      }
      ringDots.forEach(function (d, i) {
        var far = y * unit * flights[i].v;
        d.style.transform = far ? 'translate(' + (flights[i].x * far).toFixed(1) + 'px,' + (flights[i].y * far).toFixed(1) + 'px)' : '';
      });
    }

    /* sections rise in as they enter the viewport; siblings in a grid follow one after another.
       Checked on scroll (not IntersectionObserver) so nothing can stay invisible in a background tab. */
    var pending = [];
    document.querySelectorAll('.sb .sb-h2, .sb .sb-kicker, .sb-card, .sb-hero__strip a, .sb-cv__shows li, .sb-travel svg').forEach(function (el) {
      if (el.closest('.sb-hero__grid')) return; /* first screen is already there */
      var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--sb-d', Math.min(i % 4, 3) * 0.07 + 's');
      el.classList.add('sb-reveal');
      pending.push(el);
    });
    function reveal() {
      var edge = window.innerHeight * 0.92;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top > edge) return true;
        el.classList.add('is-in');
        /* drop the class once risen so hover transforms are free again */
        setTimeout(function () { el.classList.remove('sb-reveal', 'is-in'); }, 900 + parseFloat(el.style.getPropertyValue('--sb-d') || 0) * 1000);
        return false;
      });
    }

    /* scroll events already arrive once per frame; the work here is a few style writes */
    function onScroll() {
      var max = root.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
      paintHero();
      reveal();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('click', function () { setTimeout(onScroll, 50); }); /* filters and "Full CV" change the layout */
    onScroll();
    /* backup for browsers that batch scroll events (background tabs, some in-app webviews) */
    var sweep = setInterval(function () { reveal(); if (!pending.length) clearInterval(sweep); }, 400);

    if (!fine) return;

    /* dot field: the page background is a fine grid of tiny dots (GAP px), fixed to the page so it scrolls with it,
       faint everywhere and drifting with a slow animated noise, so the screen never feels flat. Colour runs cyan (left
       of the screen) to magenta (right). The canvas sits above the page in multiply mode: on white it reads as the
       background, and it never covers text. Written straight into pixels (~20 fps, or every frame while scrolling).
       Desktop pointers only. */
    var GAP = 6, BASE = 0.2;
    var field = document.createElement('canvas'), fctx = field.getContext('2d');
    field.className = 'sb-fx-lens';
    field.setAttribute('aria-hidden', 'true');
    document.body.appendChild(field);
    var W = 0, H = 0, img = null, px = null, cols = 0, colR = [], colG = [];
    function size() {
      W = Math.max(1, innerWidth); H = Math.max(1, innerHeight);  /* a window opened hidden can report 0 */
      field.width = W; field.height = H;  /* one canvas pixel per CSS pixel: a dot is one crisp square */
      img = fctx.createImageData(W, H); px = new Uint32Array(img.data.buffer);
      cols = Math.ceil(W / GAP);
      for (var c = 0; c < cols; c++) { var k = c * GAP / W; colR[c] = Math.round(240 * k); colG[c] = Math.round(255 * (1 - k)); }
    }
    size();
    window.addEventListener('resize', size);
    /* per-dot twinkle phase, from a hash of the dot's place on the page */
    function phase(c, row) { var h = Math.sin(c * 12.9898 + row * 78.233) * 43758.5453; return (h - Math.floor(h)) * 6.2832; }
    var sx = [], sx2 = [], cx2 = [];
    function drawField(t) {
      px.fill(0);
      var sy = window.scrollY, oy = sy % GAP, row0 = Math.round((sy - oy) / GAP);
      for (var c = 0; c < cols; c++) { var x = c * GAP; sx[c] = Math.sin(x * 0.011 + t * 0.35); sx2[c] = Math.sin(x * 0.006); cx2[c] = Math.cos(x * 0.006); }
      for (var y = -oy, r = 0; y < H; y += GAP, r++) {
        if (y < 0) continue;
        var gy = y + sy, row = row0 + r, syv = Math.sin(gy * 0.013 - t * 0.27), a2 = gy * 0.006 + t * 0.21, s2 = Math.sin(a2), c2 = Math.cos(a2), line = y * W;
        for (c = 0; c < cols; c++) {
          var n = sx[c] * syv + 0.6 * (sx2[c] * c2 + cx2[c] * s2) + 0.4 * Math.sin(t * 1.3 + phase(c, row));
          var a = BASE * (0.55 + 0.45 * n);
          if (a <= 0.004) continue;
          px[line + c * GAP] = (Math.round(a * 255) << 24) | (255 << 16) | (colG[c] << 8) | colR[c];
        }
      }
      fctx.putImageData(img, 0, 0);
    }

    /* cursor: the 17 dots of the logo as circles, sized like the logo's: the biggest is the pointer and, while it
       moves, the others follow it as a trail, each chasing the one before. Over anything clickable the trail folds
       into the pointer, which grows smoothly into a soft, see-through circle (CSS). The colour is that element's own:
       the first real colour of its fill, border or text; cyan when it has none (black, grey, white), magenta where cyan
       would vanish. Never black. A hairline white edge keeps the pointer readable on any background. Text fields keep
       the text cursor. */
    var SVGNS = 'http://www.w3.org/2000/svg', CYAN = '#00ffe9', MAGENTA = '#f000ff', BIG = 14, SMALL = 2;
    var trail = [], to = { x: -100, y: -100 }, seen = false, under = null, hovering = false;
    var CLICKABLE = 'a, button, [role="button"], summary, label, select, input[type="submit"], input[type="checkbox"], input[type="radio"], .sb-card';
    var TEXT = 'input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]';
    var box = document.createElement('div');
    box.className = 'sb-cursor';
    box.setAttribute('aria-hidden', 'true');
    document.body.appendChild(box);
    root.classList.add('sb-fx-cursor');
    /* sizes and arc positions come from the logo's dot shapes (brand/logo_anim.py), measured on a hidden SVG */
    var dotsUrl = SRC.replace(/sb-fx\.js.*$/, 'sb-cursor-dots.json');
    var tmp = document.createElementNS(SVGNS, 'svg');
    tmp.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
    document.body.appendChild(tmp);
    fetch(dotsUrl).then(function (r) { return r.json(); }).then(function (list) {
      var shapes = list.map(function (d) {
        var p = document.createElementNS(SVGNS, 'path'); p.setAttribute('d', d); tmp.appendChild(p);
        var b = p.getBBox(); tmp.removeChild(p);
        return { w: (b.width + b.height) / 2, cx: b.x + b.width / 2, cy: b.y + b.height / 2 };
      }).sort(function (a, b) { return b.w - a.w; });
      tmp.remove();
      var k = BIG / shapes[0].w;  /* px per logo unit: the pointer is BIG px, everything else in proportion */
      shapes.forEach(function (sh, i) {
        var el = document.createElement('div'), size = Math.max(SMALL, sh.w * k);
        el.className = 'sb-cursor__dot';
        el.style.width = el.style.height = size + 'px';
        el.style.margin = (-size / 2) + 'px 0 0 ' + (-size / 2) + 'px';
        box.insertBefore(el, box.firstChild);  /* the pointer dot ends up on top */
        trail.push({ el: el, x: -100, y: -100 });
      });
    }).catch(function () {
      root.classList.remove('sb-fx-cursor'); box.remove();  /* no shapes: the normal cursor stays */
    });
    function rgbOf(str) { var m = str && str.match(/[\d.]+/g); return m && (m.length < 4 || +m[3] > 0.5) ? m.slice(0, 3).map(Number) : null; }
    function hex(c) { return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }
    function near(c, d) { return Math.abs(c[0] - d[0]) + Math.abs(c[1] - d[1]) + Math.abs(c[2] - d[2]) < 120; }
    function light(c) { return c[0] + c[1] + c[2] > 690; }
    /* the colour behind a point: an SVG shape's fill, else the first solid background up the tree */
    function behind(el) {
      for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
        var cs = getComputedStyle(n), c;
        if (n instanceof SVGGeometryElement && (c = rgbOf(cs.fill))) return c;
        if (/^(IMG|VIDEO|CANVAS|PICTURE)$/.test(n.tagName)) return null;
        if ((c = rgbOf(cs.backgroundColor))) return c;
      }
      return [255, 255, 255];
    }
    function vivid(c) { return c && Math.max(c[0], c[1], c[2]) - Math.min(c[0], c[1], c[2]) > 70; }
    function cyanish(c) { return c && near(c, [0, 255, 233]); }
    /* the colour of a clickable element: the first real colour of its fill, border or text; else cyan (magenta on cyan) */
    function own(el) {
      var cs = getComputedStyle(el), fill = rgbOf(cs.backgroundColor) || (el instanceof SVGGeometryElement && rgbOf(cs.fill));
      var list = [fill, parseFloat(cs.borderTopWidth) > 0 && rgbOf(cs.borderTopColor), rgbOf(cs.color)];
      for (var i = 0; i < list.length; i++) if (vivid(list[i])) return cyanish(list[i]) && cyanish(fill) ? MAGENTA : hex(list[i]);
      return cyanish(fill || behind(el)) ? MAGENTA : CYAN;
    }
    function colourFor(el) {
      var hit = el.closest(CLICKABLE);
      if (hit) return own(hit);
      return cyanish(behind(el)) ? MAGENTA : CYAN;  /* cyan on cyan would vanish */
    }
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      to.x = e.clientX; to.y = e.clientY;
      if (!seen) { trail.forEach(function (t) { t.x = to.x; t.y = to.y; }); seen = true; root.classList.add('sb-cursor-on'); }
      var el = e.target.closest ? e.target : null;
      if (el === under) return;
      under = el;
      hovering = !!(el && el.closest(CLICKABLE));
      root.classList.toggle('sb-cursor-hover', hovering);
      root.classList.toggle('sb-cursor-text', !!(el && el.closest(TEXT)));
      root.style.setProperty('--sb-cur', el ? colourFor(el) : CYAN);
    }, { passive: true });
    window.addEventListener('pointerdown', function () { root.classList.add('sb-cursor-down'); });
    window.addEventListener('pointerup', function () { root.classList.remove('sb-cursor-down'); });
    document.documentElement.addEventListener('mouseleave', function () { root.classList.remove('sb-cursor-on'); seen = false; });
    function moveCursor() {
      for (var i = 0; i < trail.length; i++) {
        var t = trail[i], lead = i && !hovering ? trail[i - 1] : to;  /* hovering: everything sits on the pointer */
        t.x += (lead.x - t.x) * (i && !hovering ? 0.42 : 1);
        t.y += (lead.y - t.y) * (i && !hovering ? 0.42 : 1);
        t.el.style.transform = 'translate3d(' + t.x.toFixed(1) + 'px,' + t.y.toFixed(1) + 'px,0)';
      }
    }

    var lastField = -1e9, lastY = -1;
    function frame(now) {
      requestAnimationFrame(frame);
      if (now - lastField > 50 || window.scrollY !== lastY) { drawField(now / 1000); lastField = now; lastY = window.scrollY; }
      moveCursor();
    }
    requestAnimationFrame(frame); /* rAF pauses by itself in hidden tabs */
  });
})();
